import { createTheme } from "@mui/material/styles";

const PRIMARY_MAIN = "#00cbaf";
const PRIMARY_DARK = "#00b39b";
const PICKER_HOVER_BG = "rgba(0, 203, 175, 0.14)";

const muiTheme = createTheme({
    components: {
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    "&:hover, &:focus": {
                        backgroundColor: PICKER_HOVER_BG,
                    },
                    "&.MuiPickersDay-selected, &.Mui-selected": {
                        color: "#fff",
                        backgroundColor: PRIMARY_MAIN,
                    },
                    "&.MuiPickersDay-selected:hover, &.Mui-selected:hover": {
                        backgroundColor: PRIMARY_DARK,
                    },
                    "&.MuiPickersDay-selected:focus, &.Mui-selected:focus": {
                        backgroundColor: PRIMARY_MAIN,
                    },
                },
            },
        },
        MuiMonthPicker: {
            styleOverrides: {
                root: {
                    "& .PrivatePickersMonth-root:hover, & .PrivatePickersMonth-root:focus":
                        {
                            backgroundColor: PICKER_HOVER_BG,
                        },
                    "& .PrivatePickersMonth-root.PrivatePickersMonth-selected, & .PrivatePickersMonth-root.Mui-selected":
                        {
                            color: "#fff",
                            backgroundColor: PRIMARY_MAIN,
                        },
                    "& .PrivatePickersMonth-root.PrivatePickersMonth-selected:hover, & .PrivatePickersMonth-root.Mui-selected:hover":
                        {
                            backgroundColor: PRIMARY_DARK,
                        },
                    "& .PrivatePickersMonth-root.PrivatePickersMonth-selected:focus, & .PrivatePickersMonth-root.Mui-selected:focus":
                        {
                            backgroundColor: PRIMARY_MAIN,
                        },
                },
            },
        },
        MuiYearPicker: {
            styleOverrides: {
                root: {
                    "& .PrivatePickersYear-yearButton:hover, & .PrivatePickersYear-yearButton:focus":
                        {
                            backgroundColor: PICKER_HOVER_BG,
                        },
                    "& .PrivatePickersYear-yearButton.PrivatePickersYear-selected, & .PrivatePickersYear-yearButton.Mui-selected":
                        {
                            color: "#fff",
                            backgroundColor: PRIMARY_MAIN,
                        },
                    "& .PrivatePickersYear-yearButton.PrivatePickersYear-selected:hover, & .PrivatePickersYear-yearButton.Mui-selected:hover":
                        {
                            backgroundColor: PRIMARY_DARK,
                        },
                    "& .PrivatePickersYear-yearButton.PrivatePickersYear-selected:focus, & .PrivatePickersYear-yearButton.Mui-selected:focus":
                        {
                            backgroundColor: PRIMARY_MAIN,
                        },
                },
            },
        },
    },
});

export default muiTheme;
